<template>
    <v-data-table :headers="headers" :items="items" :loading="loading" class="elevation-1 mt-2"
        loading-text="Caricamento dati in corso" disable-pagination hide-default-footer mobile-breakpoint="0"
        no-data-text="Nessun dato disponibile" :items-per-page="-1" fixed-header height="60vh">

        <template v-slot:item.data="{ item }">
            {{ formatDate(item.data) }}
        </template>

        <template v-slot:item.tipologia="{ item }">
            <v-chip small :color="getTypeColor(item.tipologia)" dark>
                {{ item.tipologia }}
            </v-chip>

            <v-icon v-if="item.storico" title="Storico" v-tooltip.top="'Storico'">
                history_toggle_off
            </v-icon>

            <v-icon v-if="item.escludiCalcolo" title="Voce esclusa dal calcolo"
                v-tooltip.top="'Voce esclusa dal calcolo'">
                money_off
            </v-icon>
        </template>

        <template v-slot:item.entrata="{ item }">
            <span v-if="item.entrata > 0"
                :class="['font-weight-bold', item.escludiCalcolo || item.storico ? 'grey--text' : 'green--text']">
                +{{ formatCurrency(item.entrata) }}
            </span>
        </template>


        <template v-slot:item.uscita="{ item }">
            <span v-if="item.uscita > 0"
                :class="['font-weight-bold', item.escludiCalcolo || item.storico ? 'grey--text' : 'red--text']">
                -{{ formatCurrency(item.uscita) }}
            </span>
        </template>


        <template v-slot:item.runningTotal="{ item }">
            <v-chip :color="item.escludiCalcolo || item.storico ? 'grey' : (item.runningTotal >= 0 ? 'green' : 'red')"
                outlined class="font-weight-bold">
                {{ formatCurrency(item.runningTotal) }}
            </v-chip>
        </template>

        <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="$emit('edit', item)" v-tooltip.bottom="'Modifica'">
                edit
            </v-icon>
            <v-icon small class="mr-2" @click="$emit('duplicate', item)" v-tooltip.bottom="'Duplica'">
                file_copy
            </v-icon>
            <v-icon small color="red" @click="$emit('delete', item)" v-tooltip.bottom="'Elimina'">
                delete
            </v-icon>
        </template>
    </v-data-table>
</template>

<script>
export default {
    name: "CashflowDataTable",

    props: {
        items: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        headers: [
            { text: "Data", value: "data" },
            { text: "Orario", value: "orario" },
            { text: "Descrizione", value: "descrizione" },
            { text: "Tipo", value: "tipologia" },
            { text: "Entrate", value: "entrata", align: 'end' },
            { text: "Uscite", value: "uscita", align: 'end' },
            { text: "Saldo Progressivo", value: "runningTotal", align: 'end', sortable: false },
            { text: "Azioni", value: "actions", sortable: false },
        ],
    }),

    methods: {
        formatDate(isoDate) {
            return this.$functions?.formatISODate?.(isoDate) || isoDate;
        },

        formatCurrency(value) {
            return new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR"
            }).format(value);
        },

        getTypeColor(type) {
            const colors = {
                'Reale': 'blue',
                'Banca': 'purple',
                'Previsionale': 'orange'
            };
            return colors[type] || 'grey';
        }
    }
};
</script>